export default __webpack_public_path__ + "static/media/specialty-default-image.de3616f3.png";